// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"953984e8","732":"866c2384","977":"81a7a2e0"}[chunkId] + ".chunk.js";
};